module.exports = __webpack_public_path__ + "img/freediving-10.75ff1019.jpeg";